// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YiHz","right":"styles_right__OH7lI"};